import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthModel } from '../models/auth.model';
import { UserModel } from '../models/user.model';
import { RegistrationModel } from '../models/registration.model';
import {UserRoleModel} from "../models/user-role.model";
import {UserInfoModel} from "../models/user-info.model";

const API_AUTH_URL = `${environment.apiUrl}/auth`;
const API_USER_URL = `${environment.apiUrl}/auth`;
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class AuthHttpService {

  constructor(private http: HttpClient) {}



  signup(payload: RegistrationModel): Observable<any> {
    return this.http.post<UserModel>(`${API_AUTH_URL}/signup`, payload, httpOptions);
  }

  login(username: string, password: string): Observable<any> {
    const payload = {
      body: {
        username, password
      }
    };
    return this.http.post<AuthModel>(`${API_AUTH_URL}/signin`, payload, httpOptions);
  }

  forgotPassword(username: string): Observable<any> {
    let params = new HttpParams().set('username', username);
    return this.http.post<boolean>(`${API_USER_URL}/forgot-password`, null, {...httpOptions, params});
  }

  confirmForgotPassword(token: string, newPassword: string): Observable<any> {
    let params = new HttpParams()
      .set('token', token)
      .set('newPassword', newPassword);
    return this.http.post<boolean>(`${API_USER_URL}/confirm-forgot-password`, null, {...httpOptions, params});
  }

  refreshToken(refreshToken: string): Observable<any> {
    const payload = {
      body: {
        refreshToken
      }
    };
    return this.http.post<AuthModel>(`${API_AUTH_URL}/refreshtoken`, payload, httpOptions);
  }

  getUserByToken(jwt: string): Observable<UserModel> {
    const httpHeaders = new HttpHeaders().set('Authorization', `Bearer ${jwt}`);
    return this.http.get<UserModel>(`${API_AUTH_URL}/me`, {
      headers: httpHeaders,
    });
  }

  updateUser(payload: any) {
    return this.http.put(`${API_AUTH_URL}/update`, payload, httpOptions);
  }

  getUserDetail(id: string): Observable<UserModel> {
    return this.http.get<UserModel>(`${API_AUTH_URL}/${id}`);
  }

  lockUser(id: string) {
    return this.http.post(`${API_AUTH_URL}/lock/${id}`, httpOptions);
  }

  unLockUser(id: string){
    return this.http.post(`${API_AUTH_URL}/unlock/${id}`, httpOptions);
  }

  deleteUser(id: any) {
    return this.http.delete(`${API_AUTH_URL}/delete/${id}`, httpOptions);
  }

  changePassword(oldPassword: string, newPassword: string): Observable<string> {
    const params = new HttpParams()
      .set('oldPassword', oldPassword)
      .set('newPassword', newPassword);
    return this.http.post<string>(`${API_AUTH_URL}/change-password`, null, { params });
  }

  getAllUsers(): Observable<UserInfoModel[]> {
    return this.http.get<UserInfoModel[]>(`${API_AUTH_URL}/users`);
  }

  findAll(params: any): Observable<any[]> {
    return this.http.post<any[]>(`${API_AUTH_URL}/all`, params);
  }

  getAllRoles(): Observable<UserRoleModel[]> {
    return this.http.get<UserRoleModel[]>(`${API_AUTH_URL}/roles`);
  }
}
